import script from "./universityPage.vue?vue&type=script&setup=true&lang=js"
export * from "./universityPage.vue?vue&type=script&setup=true&lang=js"

import "./universityPage.vue?vue&type=style&index=0&id=1b3bf6a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b3bf6a2"]])

export default __exports__